// Deferred Service Worker Registration
// Only register after the page is fully interactive to improve TTI

export function registerServiceWorker() {
  if (import.meta.env.DEV) return;

  if ("serviceWorker" in navigator) {
    const hostname = window.location.hostname;
    const isLovablePreview = hostname.endsWith("lovable.app") && hostname.includes("preview");
    if (isLovablePreview) return;

    // Use requestIdleCallback to register SW during idle time
    // Note: On Android, installing the PWA often depends on the SW being registered early.
    const register = () => {
      fetch("/sw.js", { method: "HEAD", cache: "no-store" })
        .then((response) => {
          const contentType = response.headers.get("content-type") || "";
          if (!response.ok || !contentType.includes("javascript")) return;
          return navigator.serviceWorker.register("/sw.js", { scope: "/" });
        })
        .catch((error) => {
          console.warn("SW registration skipped:", error);
        });
    };

    const path = window.location.pathname.toLowerCase();
    const isInstallRoute = /\/(instalar|install|instaluj|installer)(\/|$)/.test(path);
    const isAndroid = /android/i.test(navigator.userAgent);

    const idleTimeout = isInstallRoute ? 800 : isAndroid ? 2000 : 5000;
    const fallbackTimeout = isInstallRoute ? 800 : isAndroid ? 2000 : 3000;

    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(register, { timeout: idleTimeout });
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(register, fallbackTimeout);
    }
  }
}
